import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React from 'react';
import { activate, defaultLocale } from './i18n.config';

export default function wrapPageElement({ element, props }) {
  return (
    <ExtendedI18nProvider i18n={i18n} {...props.pageContext}>
      {element}
    </ExtendedI18nProvider>
  );
}

function ExtendedI18nProvider({ i18n, locale, children }) {
  React.useEffect(() => {
    locale && activate(locale);
  }, [locale]);
  // console.log('locale:', locale);
  i18n._locale = locale || defaultLocale;
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
